/**
 * meta
 * 
 * treeStructure 是否使用树状结构
 * NavBar app导航栏样式配置
 * keepAlive 页面缓存
 */
const routes = [
    {
        path: "/Account",
        name: "Account",
        children: [{
            path: "ChangePassword",
            name: "ChangePassword",
            component: () => import("@/views/Account/ChangePassword")
        }, {
            path: "ForgetPassword",
            name: "ForgetPassword",
            component: () => import("@/views/Account/ForgetPassword")
        }, {
            path: "AccountSecurity",
            name: "AccountSecurity",
            component: () => import("@/views/Account/AccountSecurity")
        }, {
            path: "CompanyManagement",
            name: "CompanyManagement",
            component: () => import("@/views/Account/CompanyManagement")
        }, {
            path: "AgencyRegistration",
            name: "AgencyRegistration",
            component: () => import("@/views/Account/AgencyRegistration"),
            meta: {
                keepAlive: true
            }
        }, {
            path: "IdentityAuthentication",
            name: "IdentityAuthentication",
            component: () => import("@/views/Account/IdentityAuthentication")
        }, {
            path: "ChangePhone",
            name: "ChangePhone",
            component: () => import("@/views/Account/ChangePhone"),
        }, {
            path: "Information",
            name: "Information",
            component: () => import("@/views/Account/Information")
        }, {
            path: "MySuperior/:name?",
            name: "MySuperior",
            component: () => import("@/views/Account/MySuperior")
        }, {
            path: "Unsubscribe",
            name: "Unsubscribe",
            component: () => import("@/views/Account/Unsubscribe")
        }, {
            path: "ChangeNickname/:name",
            name: "ChangeNickname",
            component: () => import("@/views/Account/ChangeNickname")
        }]
    }, {
        path: "/Competition",
        name: "Competition",
        children: [{
            path: "EventCertificationList",
            name: "EventCertificationList",
            component: () => import("@/views/Competition/EventCertificationList"),
            meta: {
                keepAlive: true
            }
        }, {
            path: "EventCertificationSearch",
            name: "EventCertificationSearch",
            component: () => import("@/views/Competition/EventCertificationSearch"),
            meta: {
                keepAlive: true
            }
        }, {
            path: "EventCertification/:id?",
            name: "EventCertification",
            component: () => import("@/views/Competition/EventCertification"),
            meta: {
                keepAlive: true
            }
        }, {
            path: "BidEvent",
            name: "BidEvent",
            component: () => import("@/views/Competition/BidEvent"),
            meta: {
                keepAlive: true
            }
        }, {
            path: "MyEventCertification",
            name: "MyEventCertification",
            component: () => import("@/views/Competition/MyEventCertification")
        }, {
            path: "PastRecords/:id",
            name: "PastRecords",
            component: () => import("@/views/Competition/PastRecords")
        }]
    }, {
        path: "/Match",
        name: "Match",
        children: [{
            path: "MatchList",
            name: "MatchList",
            component: () => import("@/views/Match/MatchList"),
            meta: {
                keepAlive: true
            }
        }, {
            path: "MatchDetail/:id",
            name: "MatchDetail",
            component: () => import("@/views/Match/MatchDetail"),
            meta: {
                NavBar: { NavigationBar: 2, Show: 0 },
                keepAlive: true
            }
        }, {
            path: "MatchSearch",
            name: "MatchSearch",
            component: () => import("@/views/Match/MatchSearch"),
            meta: {
                keepAlive: true
            }
        }, {
            path: "GroupQRCode",
            name: "GroupQRCode",
            component: () => import("@/views/Match/GroupQRCode")
        }]
    }, {
        path: "/Integral",
        name: "Integral",
        children: [{
            path: "IntegralRanking/:eventsId?/:pointGroupId?/:pointYear?",
            name: "IntegralRanking",
            component: () => import("@/views/Integral/IntegralRanking")
        }, {
            path: "MyIntegral",
            name: "MyIntegral",
            component: () => import("@/views/Integral/MyIntegral")
        }, {
            path: "MyGrade",
            name: "MyGrade",
            component: () => import("@/views/Integral/MyGrade")
        }, {
            path: "HonorCertificates",
            name: "HonorCertificates",
            component: () => import("@/views/Integral/HonorCertificates")
        }]
    }, {
        path: "/Athletes",
        name: "Athletes",
        children: [{
            path: "AthleteCertification",
            name: "AthleteCertification",
            component: () => import("@/views/Athletes/AthleteCertification"),
            meta: {
                keepAlive: true
            }
        }, {
            path: "AthleteCertificationList",
            name: "AthleteCertificationList",
            component: () => import("@/views/Athletes/AthleteCertificationList"),
            meta: {
                keepAlive: true
            }
        }, {
            path: "AthleteCertificationSearch",
            name: "AthleteCertificationSearch",
            component: () => import("@/views/Athletes/AthleteCertificationSearch"),
            meta: {
                keepAlive: true
            }
        }, {
            path: "MyAttestationGrade",
            name: "MyAttestationGrade",
            component: () => import("@/views/Athletes/MyAttestationGrade")
        }, {
            path: "MyApplyForAssessment",
            name: "MyApplyForAssessment",
            component: () => import("@/views/Athletes/MyApplyForAssessment")
        }]
    }, {
        path: "/Enter",
        name: "Enter",
        children: [{
            path: "202/MyEnter",
            name: "MyEnter202",
            component: () => import("@/views/Enter/Custom/202/MyEnter"),
            meta: {
                NavBar: { NavigationBar: 1, Show: 1 }
            }
        }, {
            path: "202/CompanyEnter",
            name: "CompanyEnter202",
            component: () => import("@/views/Enter/Custom/202/CompanyEnter"),
            meta: {
                NavBar: { NavigationBar: 1, Show: 1 },
                keepAlive: true
            }
        }, {
            path: "202/AddMember",
            name: "AddMember202",
            component: () => import("@/views/Enter/Custom/202/AddMember"),
            meta: {
                NavBar: { NavigationBar: 1, Show: 1 }
            }
        }, {
            path: "202/CreateTeam",
            name: "CreateTeam202",
            component: () => import("@/views/Enter/Custom/202/CreateTeam"),
            meta: {
                NavBar: { NavigationBar: 1, Show: 1 }
            }
        }]
    }, {
        path: "/Rules",
        name: "Rules",
        children: [{
            path: "CertificationRegulation/:id?",
            name: "CertificationRegulation",
            component: () => import("@/views/Rules/CertificationRegulation"),
            meta: {
                NavBar: { NavigationBar: 2, Show: 0 }
            }
        }, {
            path: "JoinUS",
            name: "JoinUS",
            component: () => import("@/views/Rules/JoinUS"),
            meta: {
                NavBar: { NavigationBar: 2, Show: 0 }
            }
        }, {
            path: "CertificationAuthority",
            name: "CertificationAuthority",
            component: () => import("@/views/Rules/CertificationAuthority"),
            meta: {
                NavBar: { NavigationBar: 2, Show: 0 }
            }
        }, {
            path: "Membership",
            name: "Membership",
            component: () => import("@/views/Rules/Membership"),
            meta: {
                NavBar: { NavigationBar: 2, Show: 0 }
            }
        }, {
            path: "MemberList",
            name: "MemberList",
            component: () => import("@/views/Rules/MemberList")
        }, {
            path: "PrivacyAgreement",
            name: "PrivacyAgreement",
            component: () => import("@/views/Rules/PrivacyAgreement"),
            meta: {
                NavBar: { NavigationBar: 2, Show: 0 }
            }
        }, {
            path: "UserAgreement",
            name: "UserAgreement",
            component: () => import("@/views/Rules/UserAgreement"),
            meta: {
                NavBar: { NavigationBar: 2, Show: 0 }
            }
        }, {
            path: "HelpCenter",
            name: "HelpCenter",
            component: () => import("@/views/Rules/HelpCenter"),
            meta: {
                NavBar: { NavigationBar: 2, Show: 0 },
                keepAlive: true
            }
        }, {
            path: "HelpCenterDetail",
            name: "HelpCenterDetail",
            component: () => import("@/views/Rules/HelpCenterDetail"),
            meta: {
                NavBar: { NavigationBar: 2, Show: 0 }
            }
        }, {
            path: "ContactUs",
            name: "ContactUs",
            component: () => import("@/views/Rules/ContactUs"),
            meta: {
                NavBar: { NavigationBar: 2, Show: 0 }
            }
        }, {
            path: "OnlinePreview",
            name: "OnlinePreview",
            component: () => import("@/views/Rules/OnlinePreview")
        }]
    }, {
        path: "/PublicBenefits",
        name: "PublicBenefits",
        children: [{
            path: "DonateList",
            name: "DonateList",
            component: () => import("@/views/PublicBenefits/DonateList")
        }, {
            path: "DonateDateil/:id",
            name: "DonateDateil",
            component: () => import("@/views/PublicBenefits/DonateDateil")
        }]
    }, {
        path: "/Association",
        name: "Association",
        children: [{
            path: '/',
            redirect: '/Association/Home'
        }, {
            path: 'Home',
            name: 'AssociationHome',
            component: () => import("@/views/Association/Home")
        }, {
            path: 'Business',
            name: 'Business',
            component: () => import("@/views/Association/Business")
        }, {
            path: 'CoreTeam',
            name: 'CoreTeam',
            component: () => import("@/views/Association/CoreTeam")
        }, {
            path: 'OfficialMedia',
            name: 'OfficialMedia',
            component: () => import("@/views/Association/OfficialMedia"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'MemberList',
            name: 'AssociationMemberList',
            component: () => import("@/views/Association/MemberList"),
        }, {
            path: 'OrganizationalStructure',
            name: 'OrganizationalStructure',
            component: () => import("@/views/Association/OrganizationalStructure")
        }, {
            path: 'Constitution',
            name: 'Constitution',
            component: () => import("@/views/Association/Constitution"),
        }, {
            path: 'CooperativeResources',
            name: 'CooperativeResources',
            component: () => import("@/views/Association/CooperativeResources"),
        }]
    }, {
        path: "/Enroll",
        name: "Enroll",
        children: [{
            path: 'TeamPersonnel',
            name: "TeamPersonnel",
            component: () => import("@/views/Enroll/TeamPersonnel"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'CreateTeam',
            name: "CreateTeam",
            component: () => import("@/views/Enroll/CreateTeam"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'AddTeam',
            name: "AddTeam",
            component: () => import("@/views/Enroll/AddTeam"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'AddMember',
            name: "AddMember",
            component: () => import("@/views/Enroll/AddMember")
        }, {
            path: 'MemberUpdatePhone',
            name: "MemberUpdatePhone",
            component: () => import("@/views/Enroll/UpdatePhone")
        }, {
            path: 'AdmissionInformation',
            name: "AdmissionInformation",
            component: () => import("@/views/Enroll/AdmissionInformation")
        }, {
            path: 'UpdateTeamPersonnel',
            name: "UpdateTeamPersonnel",
            component: () => import("@/views/Enroll/UpdateTeamPersonnel"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'EnrollRecord',
            name: "EnrollRecord",
            component: () => import("@/views/Enroll/EnrollRecord"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'TeamAuditDetail',
            name: "TeamAuditDetail",
            component: () => import("@/views/Enroll/TeamAuditDetail")
        }, {
            path: 'LookTeamAuditDetail',
            name: "LookTeamAuditDetail",
            component: () => import("@/views/Enroll/LookTeamAuditDetail")
        }, {
            path: 'EnrollDetail',
            name: "EnrollDetail",
            component: () => import("@/views/Enroll/EnrollDetail")
        }, {
            path: 'BulletinBoard',
            name: "BulletinBoard",
            component: () => import("@/views/Enroll/BulletinBoard")
        }, {
            path: 'Report',
            name: "Report",
            component: () => import("@/views/Enroll/Report")
        }, {
            path: 'OneselfEnroll/AuditDetail',
            name: "AuditDetail",
            component: () => import("@/views/Enroll/OneselfEnroll/AuditDetail"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'OneselfEnroll/EnrollDetail',
            name: "EnrollDetail",
            component: () => import("@/views/Enroll/OneselfEnroll/EnrollDetail")
        }, {
            path: 'OneselfEnroll/Personnel',
            name: "Personnel",
            component: () => import("@/views/Enroll/OneselfEnroll/Personnel"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'OneselfEnroll/UpdatePersonnel',
            name: "UpdatePersonnel",
            component: () => import("@/views/Enroll/OneselfEnroll/UpdatePersonnel"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'OneselfEnroll/MyInfo',
            name: "MyInfo",
            component: () => import("@/views/Enroll/OneselfEnroll/MyInfo")
        }, {
            path: 'OneselfEnroll/TeammateInfo',
            name: "TeammateInfo",
            component: () => import("@/views/Enroll/OneselfEnroll/TeammateInfo"),
            meta: {
                keepAlive: true
            }
        }]
    }, {
        path: "/MasterScore",
        name: "MasterScore",
        children: [{
            path: 'Home',
            redirect: '/MasterScore/404'
            //   name: "Home",
            //   component: () => import("@/views/MasterScore/Home"),
            //   meta: {
            //     keepAlive: true
            //   }
        }, {
            path: 'RankingList',
            redirect: '/MasterScore/404'
            //   name: "RankingList",
            //   component: () => import("@/views/MasterScore/RankingList"),
            //   meta: {
            //     keepAlive: true
            //   }
        }, {
            path: 'MatchSearch',
            redirect: '/MasterScore/404'
            //   name: "MatchSearch",
            //   component: () => import("@/views/MasterScore/MatchSearch"),
            //   meta: {
            //     keepAlive: true
            //   }
        }, {
            path: 'GradeList',
            redirect: '/MasterScore/404'
            //   name: "GradeList",
            //   component: () => import("@/views/MasterScore/GradeList")
        }, {
            path: 'MyGrade',
            redirect: '/MasterScore/404'
            //   name: "MyGrade",
            //   component: () => import("@/views/MasterScore/MyGrade")
        }, {
            path: '404',
            name: "404",
            component: () => import("@/views/MasterScore/404")
        }]
    }, {
        path: "/News",
        name: "News",
        children: [{
            path: 'Home',
            name: "NewsHome",
            component: () => import("@/views/News/Home")
        }]
    }, {
        path: "/Pay",
        name: "Pay",
        children: [{
            path: 'EnrollCashier',
            name: "EnrollCashier",
            component: () => import("@/views/Pay/EnrollCashier")
        }]
    }, {
        path: "/RefereeCoach",
        name: "RefereeCoach",
        children: [{
            path: 'RefereeListHome',
            redirect: '/Occupation/RefereeCenter'
        }, {
            path: 'RefereeSearch',
            redirect: '/Occupation/RefereeSearch'
        }, {
            path: 'CoachListHome',
            name: "CoachListHome",
            component: () => import("@/views/RefereeCoach/CoachListHome"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'CoachSearch',
            name: "CoachSearch",
            component: () => import("@/views/RefereeCoach/CoachSearch"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'OccupationDetail/:type/:id',
            name: "OccupationDetail",
            component: () => import("@/views/RefereeCoach/OccupationDetail")
        }]
    }, {
        path: "/Occupation",
        name: "Occupation",
        children: [{
            path: 'RefereeCenter',
            name: "RefereeCenter",
            component: () => import("@/views/Occupation/RefereeCenter"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'RefereeSearch',
            name: "RefereeSearch",
            component: () => import("@/views/Occupation/RefereeSearch"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'RefereeDetail/:refereeId',
            name: "RefereeDetail",
            component: () => import("@/views/Occupation/referee/Detail"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'RefereeExperienceDetail/:experienceId',
            name: "RefereeExperienceDetail",
            component: () => import("@/views/Occupation/referee/ExperienceDetail")
        }]
    }, {
        path: "/Training",
        name: "Training",
        children: [{
            path: 'TrainingDetail/:id',
            name: "TrainingDetail",
            component: () => import("@/views/Training/TrainingDetail"),
            meta: {
                keepAlive: true
            }
        }]
    }, {
        path: "/SerialMatch",
        name: "SerialMatch",
        children: [{
            path: 'MatchHome/:id',
            name: "MatchHome",
            component: () => import("@/views/SerialMatch/MatchHome"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'MatchInformation/:id',
            name: "MatchInformation",
            component: () => import("@/views/SerialMatch/MatchInformation"),
            meta: {
                keepAlive: true
            }
        }, {
            path: 'FileDownload',
            name: "FileDownload",
            component: () => import("@/views/SerialMatch/FileDownload")
        }, {
            path: 'ImagePreview',
            name: "ImagePreview",
            component: () => import("@/views/SerialMatch/ImagePreview")
        }]
    }, {
        path: "*",
        redirect: "/404"
    }, {
        path: "/404",
        component: () => import("@/views/404")
    }, {
        path: "/appTest",//app测试
        component: () => import("@/views/appTest")
    }
];
const testRoutes = [
    {
        path: "/",
        name: "Home",
        component: () => import("@/views/Home"),
        meta: {
            keepAlive: true
        }
    }
]
function select(arr, path = '') {
    var arr1 = [];
    for (var i = 0; i < arr.length; i++) {
        let obj = arr[i];
        if (obj.meta && obj.meta.treeStructure) {
            arr1.push(obj);
        } else {
            let path2 = '';
            if (obj.path == '*' || obj.path.match(/^\//)) {
                path2 = path + obj.path;
            } else {
                path2 = path + '/' + obj.path;
            }
            if (obj.children && obj.children.length > 0) {
                let childrenArr = select(obj.children, path2);
                arr1.push(...childrenArr);
            } else {
                obj.path = path2;
                arr1.push(obj);
            }
        }
    }
    return arr1;
}
var arr = [];
arr.push(...select(routes));
if (process.env.NODE_ENV == "production") {
} else {
    arr.push(...select(testRoutes));
}
export default arr;